export default __webpack_public_path__ + "static/media/capitalGainImg.06d0980f.svg";